import CommonLayout from "./commonLayout/CommonLayout";
import WelcomeScreen from "./Landing/WelcomeScreen";
import HospitalLogin from "./HospitalLogin/HospitalLogin";
import DoctorLogin from "./DoctorLogin/DoctorLogin";
import DocForgotPassword from "./DoctorLogin/ForgotPassword";
import HospitalForgotPass from "./HospitalLogin/ForgotHospitalPass";
import ValidateSession from "./ValidateSession/ValidateSession";
import HomeLayout from "./HomeLayout/HomeLayout";
import HospitalDashboard from "./HospitalDashboard/HospitalDashboard";
import ManageDoctor from "./ManageDoctor/ManageDoctor";
import DoctorProfileView from "./DoctorProfileView/DoctorProfileView";
import ViewClinicProfile from "./viewClinicProfile/viewClinicProfile";
import ApprovedAppointment from "./ApproveAppointment/ApproveAppointment";
import RequestAppointment from "./RequestAppointment/RequestAppointment";
import ClinicReport from "./Report/clinicReport";
import WarningPop from "./warningPop/warningPop";
import NewZoom from "../Utils/zoom/zoomnew";
import NewZoomA from "../Utils/zoom/zoomTest";
import WaivedOffAppointments from "./waivedOffAppointments/WaivedOffAppointments"; 
import DateSelection from "../Components/ReassignDoctor/DateSelection";
import DoctorSelection from "../Components/ReassignDoctor/DoctorSelection"

const Component = {
  CommonLayout,
  WelcomeScreen,
  HospitalLogin,
  DoctorLogin,
  DocForgotPassword,
  HospitalForgotPass,
  ValidateSession,
  HomeLayout,
  HospitalDashboard,
  ManageDoctor,
  DoctorProfileView,
  ViewClinicProfile,
  ApprovedAppointment,
  RequestAppointment,
  ClinicReport,
  WarningPop,
  NewZoom,
  NewZoomA,
  WaivedOffAppointments,
  DateSelection,
  DoctorSelection
};

export default Component;
